import { combineReducers, configureStore } from "@reduxjs/toolkit";
import alarmsSlice from "./alarmsSlice";
import configurationSlice from "./configurationSlice";
import devicesSlice from "./devicesSlice";
import deviceGroupsSlice from "./deviceGroupsSlice";
import profileSettingsSlice from "./profileSettingsSlice";
import billingInfoSlice from "./billingInfoSlice";
import feedsSlice from "./feedsSlice";
import usersSlice from "./usersSlice";
import weatherSlice from "./weatherSlice";
import { APIStatus } from "./APIStatus";
import organizationsSlice from "./organizationsSlice";
import feedRulesSlice from "./feedRulesSlice";
import triggersSlice from "./triggersSlice";
import commentsSlice from "./commentsSlice";
import resetPasswordSlice from "./resetPasswordSlice";
import assetSlice from "./assetSlice";
import rEyeDashboardSlice from "./rEyeDashboardSlice";

const rootReducer = (state, action) => {
  if (action.type === APIStatus.closeSession) {
    state = undefined;
  }
  return combinedReducer(state, action);
};

const combinedReducer = combineReducers({
  assetSlice: assetSlice,
  devicesSlice: devicesSlice,
  deviceGroupsSlice: deviceGroupsSlice,
  feedsSlice: feedsSlice,
  usersSlice: usersSlice,
  triggersSlice: triggersSlice,
  alarmsSlice: alarmsSlice,
  weatherSlice: weatherSlice,
  configurationSlice: configurationSlice,
  organizationsSlice: organizationsSlice,
  feedRulesSlice: feedRulesSlice,
  resetPasswordSlice: resetPasswordSlice,
  commentsSlice: commentsSlice,
  profileSettingsSlice: profileSettingsSlice,
  billingInfoSlice: billingInfoSlice,
  rEyeDashboardSlice: rEyeDashboardSlice,
});

export const Store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
  devTools: true,
});
